import { FC, ReactNode } from 'react';
import styles from './Driftmeddelanden.module.css';
import { SystemBanner } from '@kpa/kul';
import { driftmeddelandenQueryOptions } from './driftmeddelandenQuery';
import { useQuery } from '@tanstack/react-query';

type AlertVariant = 'information' | 'attention' | 'critical';

const Driftmeddelanden: FC = (): ReactNode => {
  const driftmeddelanden = useQuery(driftmeddelandenQueryOptions);

  return (
    <div className={styles.Driftmeddelanden}>
      {driftmeddelanden.isSuccess && driftmeddelanden.data.map((d) => {
        return (
          <div key={d.rubrik} role="alert" aria-live="assertive" className={styles.fullWidth}>

            <SystemBanner
              variant={d.variant as AlertVariant}
              title={d.rubrik ?? ''}
              className={styles.bar}
            >
              {d.förklaring ?? ''}
            </SystemBanner>
          </div>
        );
      })}
    </div>
  );
};

export default Driftmeddelanden;
